const URL = 'property-clickeds'

export default ({ apiClient }) => ({
  list(params) {
    return apiClient.get(URL, {}, params)
  },
  show(id) {
    return apiClient.get(`${URL}/${id}`, {}, {})
  },
  store(payload) {
    return apiClient.axios().post(URL, payload)
  },
  update(id, payload) {
    return apiClient.axios().post(`${URL}/${id}`, payload)
  },
  delete(id) {
    return apiClient.delete(`${URL}/${id}`)
  },
})
